import React, { useCallback, useEffect, useState } from 'react';
import styles from './netwatcher.module.scss';
import { inWindow } from 'api';
import { getIn18Text } from 'api';
export const useNetStatus = () => {
    const [online, setOnline] = useState(inWindow() ? window.navigator.onLine : true);
    const changeNetStatusOnline = useCallback(() => {
        setOnline(!0);
    }, []);
    const changeNetStatusOffline = useCallback(() => {
        setOnline(false);
    }, []);
    useEffect(() => {
        window.addEventListener('online', changeNetStatusOnline);
        window.addEventListener('offline', changeNetStatusOffline);
        return () => {
            window.removeEventListener('online', changeNetStatusOnline);
            window.removeEventListener('offline', changeNetStatusOffline);
        };
    }, [changeNetStatusOffline, changeNetStatusOnline]);
    return online;
};
const NetWatcher = ({ children, style }) => {
    const online = useNetStatus();
    if (online) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { className: styles.offlineGuardWrap, style: style },
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles.bgImg }),
            React.createElement("div", { className: styles.tip }, getIn18Text('AIYADUANWANG')))));
};
export default NetWatcher;
